module.exports = __webpack_public_path__ + "20c0f3b3.png";